import React from "react";
import "./Numbers.scss";
import NumBox from "./NumBox/NumBox";

const Numbers = () => {
  return (
    <div className="num-boxes">

      <NumBox num="30" bgcolor="#153240" title="books published"/>
      <NumBox num="25" bgcolor="#2E6E8D" title="years being an educator"/>
      <NumBox num="1000" bgcolor="#F58800"title="lectures conveyed"/>
      <NumBox num="50,000" bgcolor="#F8BC24" title="students guided"/>

    </div>
  );
};

export default Numbers;
